

export enum BooleanOperator {
  AND = 'AND' ,
  OR = 'OR' ,
  XOR = 'XOR'
}

/*export class  BooleanOperatorEnumUtil {

  constructor() {
  }

  static getType(type: number): string {
    switch (type) {
      case 0: return 'AND';
      case 1: return 'OR';
      case 2: return 'XOR';
    }
  }
}*/
